// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import PropTypes from "prop-types";
// import strings from "../../utils/property-file/Employeedetails.json";
// import moment from "moment";
// import { toast } from "react-toastify";
// import './employeeList.css'

// const CheckoutModal = ({ show, onConfirm, onCancel, inTime,isCheckin }) => {
//   const [showCheckInOut,setShowCheckInOut] = useState(true)
//   const [isCheckoutTimeEditable, setIsCheckoutTimeEditable] = useState(false);
//  const [selectedTime, setSelectedTime] = useState('');
//   const [isSelectedTimeChanged, setIsSelectedTimeChanged] = useState(false);
//   const [isSkipped, setIsSkipped] = useState(false);

//   useEffect(() => {
//     const isEditable = localStorage.getItem("isCheckoutTimeEditable");
//     setIsCheckoutTimeEditable(JSON.parse(isEditable));

//   }, []);

//   const handleTimeChange = (e) => {
//     console.log("handleTimeChange::",e);
    
//     setSelectedTime(e.target.value);
//     setIsSelectedTimeChanged(true)
//   };

//   const isValidCheckoutTime = () => {
//     if (!selectedTime || !inTime) return false;
// ``
//     const selected = moment(selectedTime, "HH:mm");
//     const inMoment = moment(inTime);

//     return selected.isAfter(inMoment);
//   };

//   const handleConfirm = () => {
//     if (isCheckoutTimeEditable) {
//       if (!isValidCheckoutTime() && !isCheckin) {
//         toast.error(strings.checkoutErrorMsg, { toastId: "error6" });
//         return;
//       }
//       onConfirm(selectedTime);
//     } else {
//       onConfirm(null);
//     }
//     setIsSelectedTimeChanged(false);
//     onCancel();
//   };

//   useEffect(() => {
//     setShowCheckInOut(show);
//   }, [show]);

//    useEffect(() => {
//     if (showCheckInOut) {
//       const modalContent = document.querySelector(".checkout-dialog .modal-content");
//       if (modalContent) {
//         modalContent.classList.add("modal-content-checkout");
//       }
//       const now = new Date();
//       const currentTime = now.toTimeString().slice(0, 5);
//       setSelectedTime(currentTime);
//     }
  
//   }, [showCheckInOut]);


//     useEffect(() => {
//     if (isSkipped) {
//       const modalContent = document.querySelector(".skip-checkout-dialog .modal-content");
//       if (modalContent) {
//         modalContent.classList.add("modal-content-checkout");
//       }
//     }
//   }, [isSkipped]);

//   const handleCancel = () => {
//     setSelectedTime("");
//     setShowCheckInOut(false);
//     onCancel()
//   }

//   const handleSkipTime = ()=>{
//     console.log("handleSkipTime::");
    
//     setIsSkipped(true);
//     setShowCheckInOut(false);
//   }

//   const handleSkipCancel = () =>{
//     setIsSkipped(false);
//     setShowCheckInOut(true)
//   }
   
//   const handleSkipConfirm = () =>{
//    const now = new Date();
//     const currentTime = now.toTimeString().slice(0, 5);
//     setSelectedTime(currentTime);
//     setShowCheckInOut(true)
//     setIsSkipped(false)
//   }

  
//   return (
//     <>
//     {isSkipped && <Modal show={isSkipped} onHide={handleSkipCancel} size="sm" centered dialogClassName="skip-checkout-dialog">
//       <Modal.Body className="d-flex justify-content-center flex-column align-items-center ">
//           <div>{isCheckin ? strings.skipCheckInTimeConformation : strings.skipCheckOutTimeConformation}</div>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleSkipCancel}>
//           {strings.checkoutCancel}
//         </Button>
//         <Button variant="primary" onClick={handleSkipConfirm}>
//           {strings.skipOk}
//         </Button>
//       </Modal.Footer>

//     </Modal>} 
//     <Modal show={showCheckInOut} onHide={handleCancel} size="sm" centered dialogClassName="checkout-dialog"
//       className="check-modal">

//       <Modal.Header>
//         <p className="heading-text">
//           {!isCheckoutTimeEditable ? strings.checkoutConformation : !isCheckin ? strings.checkoutTime : strings.checkInTime}
//         </p>
//       </Modal.Header>

//       <Modal.Body className="d-flex justify-content-center flex-column align-items-center">
//         {isCheckoutTimeEditable ? (
//           <>
//             <Form.Control
//               type="time"
//               value={selectedTime}
//                onChange={(e) => handleTimeChange(e)}
//               className="form-control"
//               autoFocus
//             />
//             <p className="skip-btn" onClick={()=>{handleSkipTime}}>{isSelectedTimeChanged ? strings.checkInoutTimeSkip :""}</p>
//             <div className="mt-3">{!isCheckin ? strings.checkoutTimeNote : strings.checkInTimeNote}</div>
//           </>
//         ) : (
//           <div>{ strings.checkoutConformationMsg}</div>
//         )}
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleCancel}>
//           {strings.checkoutCancel}
//         </Button>
//         <Button variant="primary" onClick={handleConfirm}>
//           {!isCheckin ? strings.checkoutYes : strings.checkInYes}
//         </Button>
//       </Modal.Footer>

//     </Modal>
//     </>
//   );
// };

// CheckoutModal.propTypes = {
//   show: PropTypes.bool.isRequired,
//   onConfirm: PropTypes.func.isRequired,
//   onCancel: PropTypes.func.isRequired,
//   inTime: PropTypes.string,
//   isCheckin : PropTypes.bool.isRequired,
// };

// export default CheckoutModal;

import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import strings from "../../utils/property-file/Employeedetails.json";
import moment from "moment";
import { toast } from "react-toastify";
import './employeeList.css';

const CheckoutModal = ({ show, onConfirm, onCancel, inTime, isCheckin }) => {
  const [isCheckoutTimeEditable, setIsCheckoutTimeEditable] = useState(false);
  const [selectedTime, setSelectedTime] = useState(() => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); 
  });
  const [isSelectedTimeChanged, setIsSelectedTimeChanged] = useState(false);
  const [isSkipped, setIsSkipped] = useState(false);

  useEffect(() => {
    const isEditable = localStorage.getItem("isCheckoutTimeEditable");
    setIsCheckoutTimeEditable(JSON.parse(isEditable));
  }, []);

   useEffect(() => {
    if (isSkipped) {
      const modalContent = document.querySelector(".skip-checkout-dialog .modal-content");
      if (modalContent) {
        modalContent.classList.add("modal-content-checkout");
      }
    }
  }, [isSkipped]);


 useEffect(() => {
    if (show) {
      const now = new Date();
      const currentTime = now.toTimeString().slice(0, 5);
      setSelectedTime(currentTime)
      const modalContent = document.querySelector(".checkout-dialog .modal-content");
      if (modalContent) {
        modalContent.classList.add("modal-content-checkout");
      }
    }
  }, [show]);

 

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
    setIsSelectedTimeChanged(true);
  };

  const isValidCheckoutTime = () => {
    if (!selectedTime || !inTime) return false;
    const selected = moment(selectedTime, "HH:mm");
    const inMoment = moment(inTime);
    return selected.isAfter(inMoment);
  };

  const handleConfirm = () => {
    if (isCheckoutTimeEditable) {
      if (!isValidCheckoutTime() && !isCheckin) {
        toast.error(strings.checkoutErrorMsg, { toastId: "error6" });
        return;
      }
      onConfirm(selectedTime);
    } else {
      onConfirm(null);
    }
    setIsSelectedTimeChanged(false);
    onCancel();
  };

  const handleCancel = () => {
    setSelectedTime('');
    onCancel();
  };

  const handleSkipTime = () => {
    setIsSkipped(true);
  };

  const handleSkipCancel = () => {
    setIsSkipped(false);
  };

  const handleSkipConfirm = () => {
    const now = new Date();
    const currentTime = now.toTimeString().slice(0, 5);
    setSelectedTime(currentTime);
    setIsSkipped(false);
  };

  return (
    <>
      {/* Skip Modal */}
      {isSkipped && (
        <Modal
          show={isSkipped}
          onHide={handleSkipCancel}
          size="sm"
          centered
          dialogClassName="skip-checkout-dialog"
        >
          <Modal.Body className="d-flex justify-content-center flex-column align-items-center">
            <div>
              {isCheckin
                ? strings.skipCheckInTimeConformation
                : strings.skipCheckOutTimeConformation}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleSkipCancel}>
              {strings.checkoutCancel}
            </Button>
            <Button variant="primary" onClick={handleSkipConfirm}>
              {strings.skipOk}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Main Modal */}
      <Modal
        show={show}
        onHide={handleCancel}
        size="sm"
        centered
        dialogClassName="checkout-dialog"
        className="check-modal"
      >
        <Modal.Header>
          <p className="heading-text">
            {!isCheckoutTimeEditable
              ? strings.checkoutConformation
              : !isCheckin
              ? strings.checkoutTime
              : strings.checkInTime}
          </p>
        </Modal.Header>

        <Modal.Body className="d-flex justify-content-center flex-column align-items-center">
          {isCheckoutTimeEditable ? (
            <>
              <Form.Control
                type="time"
                value={selectedTime}
                onChange={handleTimeChange}
                className="form-control"
                autoFocus
              />
              <p className="skip-btn" onClick={handleSkipTime}>
                {isSelectedTimeChanged ? strings.checkInoutTimeSkip : ""}
              </p>
              <div className="mt-3">
                {!isCheckin ? strings.checkoutTimeNote : strings.checkInTimeNote}
              </div>
            </>
          ) : (
            <div>{strings.checkoutConformationMsg}</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            {strings.checkoutCancel}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {!isCheckin ? strings.checkoutYes : strings.checkInYes}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

CheckoutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  inTime: PropTypes.string,
  isCheckin: PropTypes.bool.isRequired,
};

export default CheckoutModal;

